declare const gital_search_status:
	| {
			notice?: string;
	  }
	| undefined;

document.addEventListener('DOMContentLoaded', (): void => {
	if (!document.body.classList.contains('g-search-disabled')) {
		return;
	}

	const inputs = document.querySelectorAll<HTMLInputElement>(
		'.search-bg input[type="text"], .mobile-search-form input[name="s"]'
	);

	if (!inputs.length) {
		return;
	}

	inputs.forEach((input) => {
		input.disabled = true;
		input.setAttribute('aria-disabled', 'true');
	});

	const noticeText = gital_search_status?.notice?.trim();

	if (!noticeText) {
		return;
	}

	inputs.forEach((input) => {
		const notice = document.createElement('p');
		notice.classList.add('g-search-status__notice');
		notice.textContent = noticeText;
		input.insertAdjacentElement('afterend', notice);
	});
});
